module.exports = __webpack_public_path__ + "img/client13.a431dad4.png";